export var SapJobStatus;
(function (SapJobStatus) {
    SapJobStatus["SAP_JOB_STATUS_PENDING"] = "PENDING";
    SapJobStatus["SAP_JOB_STATUS_RUNNING"] = "RUNNING";
    SapJobStatus["SAP_JOB_STATUS_COMPLETED"] = "COMPLETED";
    SapJobStatus["SAP_JOB_STATUS_FAILED"] = "FAILED";
})(SapJobStatus || (SapJobStatus = {}));
